import React, { useEffect, useRef, useState } from 'react';

const LS_W = 'chatPane.w';
const LS_COLLAPSED = 'chatPane.collapsed';

export default function SplitPane({
    min = 68,
    max = 520,
    defaultW = 300,
    left,
    right,
    headerLeft = null,
    narrowAt = 120
}) {
    const [w, setW] = useState(() => {
        const saved = Number(localStorage.getItem(LS_W) || defaultW);
        return Math.min(Math.max(saved, min), max);
    });
    const [collapsed, setCollapsed] = useState(() => localStorage.getItem(LS_COLLAPSED) === '1');
    const wrapRef = useRef(null);
    const dragging = useRef(false);

    useEffect(() => { localStorage.setItem(LS_W, String(w)); }, [w]);
    useEffect(() => { localStorage.setItem(LS_COLLAPSED, collapsed ? '1' : '0'); }, [collapsed]);

    useEffect(() => {
        const onMove = (e) => {
            if (!dragging.current) return;
            const rect = wrapRef.current.getBoundingClientRect();
            const x = e.touches ? e.touches[0].clientX : e.clientX;
            const newW = x - rect.left;
            setCollapsed(false);
            setW(Math.min(Math.max(newW, min), max));
            e.preventDefault();
        };
        const onUp = () => { dragging.current = false; document.body.style.userSelect = ''; };
        window.addEventListener('mousemove', onMove);
        window.addEventListener('mouseup', onUp);
        window.addEventListener('touchmove', onMove, { passive: false });
        window.addEventListener('touchend', onUp);
        return () => {
            window.removeEventListener('mousemove', onMove);
            window.removeEventListener('mouseup', onUp);
            window.removeEventListener('touchmove', onMove);
            window.removeEventListener('touchend', onUp);
        };
    }, [min, max]);

    const startDrag = (e) => { dragging.current = true; document.body.style.userSelect = 'none'; e.preventDefault(); };
    const toggleCollapsed = () => setCollapsed(v => !v);

    const isNarrow = (collapsed ? min : w) < narrowAt;

    return (
        <div ref={wrapRef} className="splitPane">
            <aside
                className={[
                    'splitPane__left',
                    collapsed ? 'is-collapsed' : '',
                    isNarrow ? 'is-narrow' : ''
                ].join(' ')}
                style={{ width: collapsed ? min : w }}
            >
                <div className="splitPane__leftHead">
                    {headerLeft}
                    <button
                        className="splitPane__collapseBtn"
                        onClick={toggleCollapsed}
                        title={collapsed ? 'Развернуть' : 'Свернуть'}
                    >
                        {collapsed ? '»' : '«'}
                    </button>
                </div>
                <div className="splitPane__leftBody">{left}</div>
            </aside>

            <div
                className="splitPane__resizer"
                onMouseDown={startDrag}
                onTouchStart={startDrag}
                onDoubleClick={toggleCollapsed}
                title="Потяни, чтобы изменить ширину (двойной клик — свернуть)"
            />

            <main className="splitPane__right">{right}</main>
        </div>
    );
}
